import { BatchedMesh, BufferGeometry, type Material } from "three"

export default function createBatchedMeshWithGeometryList(
  maxInstanceCount: number,
  geometryList: Array<BufferGeometry>,
  material: Material,
): BatchedMesh {

  let maxVertexCount = 0
  let maxIndexCount = 0

  for (let i = 0; i < geometryList.length; i++) {
    const geometry = geometryList[i]
    maxVertexCount += geometry.attributes.position.count
    // We will assume the geometry has an index
    // until a counter-scenario actually happens.
    // maxIndexCount += geometry.getIndex()!.count

    const index = geometry.getIndex();
    const vertexCount = index ? index.count : geometry.attributes.position.count;
    maxIndexCount += vertexCount;
  }

  const batchedMesh = new BatchedMesh(maxInstanceCount, maxVertexCount, maxIndexCount, material)
  batchedMesh.userData.geometryList = geometryList

  for (let i = 0; i < geometryList.length; i++) {
    const geometry = geometryList[i]
    geometry.userData.bm = batchedMesh
  }

  return batchedMesh
}